import React from "react";
import type { SkeletonProps } from "./SkeletonTypes";
import SkeletonHybrid from "./SkeletonHybrid";

/**
 * Skeleton component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (props, ref) => <SkeletonHybrid {...props} ref={ref} />
);

Skeleton.displayName = "Skeleton";
export default Skeleton;
